<template>
  <div style="max-width: 400px; margin: auto">
    <v-row justify="center">
      <v-col cols="5">
        <img
          class="sri-grade-img"
          :src="require(`@/assets/svg/${sriGrade}.svg`)"
        />
      </v-col>
      <v-col cols="5">
        <v-progress-circular :size="130" :width="15" value="58" color="#f3a023"
          ><span class="sri-score">{{ sriScore }}%</span></v-progress-circular
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex align-center justify-center"
        ><div>
          <v-img
            class="kfscore-image"
            src="@/assets/kfscore/ee.png"
          ></v-img></div
      ></v-col>
      <v-col class="d-flex align-center"
        ><span class="kfscore-text"
          >Ability to optimize energy efficiency and overall in-use
          performance</span
        ></v-col
      >
      <v-col class="d-flex align-center">
        <v-progress-circular
          :size="80"
          :width="10"
          :value="scoresEE"
          :color="gaugeColor(scoresEE)"
          ><span class="kfscore-score"
            >{{ scoresEE.toFixed(0) }}%</span
          ></v-progress-circular
        ></v-col
      >
    </v-row>
    <v-row>
      <v-col class="d-flex align-center justify-center"
        ><div>
          <v-img
            class="kfscore-image"
            src="@/assets/kfscore/ao.png"
          ></v-img></div
      ></v-col>
      <v-col class="d-flex align-center"
        ><span class="kfscore-text"
          >Ability to adapt building operation to the needs of the
          occupant</span
        ></v-col
      >
      <v-col class="d-flex align-center">
        <v-progress-circular
          :size="80"
          :width="10"
          :value="scoresAO"
          :color="gaugeColor(scoresAO)"
          ><span class="kfscore-score"
            >{{ scoresAO.toFixed(0) }}%</span
          ></v-progress-circular
        ></v-col
      >
    </v-row>
    <v-row>
      <v-col class="d-flex align-center justify-center"
        ><div>
          <v-img
            class="kfscore-image"
            src="@/assets/kfscore/asg.png"
          ></v-img></div
      ></v-col>
      <v-col class="d-flex align-center"
        ><span class="kfscore-text"
          >Ability to adapt to the signals from the grid (energy
          flexibility)</span
        ></v-col
      >
      <v-col class="d-flex align-center">
        <v-progress-circular
          :size="80"
          :width="10"
          :value="scoresASG"
          :color="gaugeColor(scoresASG)"
          ><span class="kfscore-score"
            >{{ scoresASG.toFixed(0) }}%</span
          ></v-progress-circular
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    sriGrade: String,
    sriScore: Number,
    scoresEE: Number,
    scoresAO: Number,
    scoresASG: Number,
  },
  methods: {
    gaugeColor: function (value) {
      if (value < 33) return "#e94d1f";
      if (value < 66) return "#f3a023";
      return "#179b94";
    },
  },
};
</script>

<style>
.kfscore-image {
  width: 65px;
}
.kfscore-text {
  display: block;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
}
.kfscore-score {
  font-size: 20px;
}
.sri-score {
  font-size: 40px;
}
.sri-grade-img {
  width: 130px;
}
</style>
